export default "__VITE_ASSET__BeAQEyVt__"